<script>
import { headroom } from 'vue-headroom';
import smoothReflow from 'vue-smooth-reflow';
import { mapActions, mapGetters } from 'vuex';
import IconDownTriangle from './icons/IconDownTriangle';

export default {
    name: 'Navigation',
    components: {
        headroom,
        IconDownTriangle,
    },
    mixins: [smoothReflow],
    data() {
        return {
            showNavigationBooking: false,
            showCovidInfo: false,
            subMenuShowing: false,
            submenu: null,
            submenuTop: 200,
            submenuLeft: 200,
            showingMobileSubmenu: null,
            timeout: null,
            openTopMenuLinks: false,
            openLanguageSelect: false,
            desktopPinned: false,
            lastScrollTop: 20,
            collapsed: false,
            faced: true
        };
    },
    computed: {
        ...mapGetters('devise', ['breakpoint']),
        ...mapGetters(['appState']),
        mobileMenuOpen: {
            get() {
                return this.appState.mobileMenuOpen;
            },
            set(newValue) {
                this.setAppStateProperty({
                    property: 'mobileMenuOpen',
                    value: newValue,
                });
            },
        },
        isVideoTakeover() {
            if (
                this.currentPage.slices &&
                this.currentPage.slices[0] &&
                this.currentPage.slices[0].metadata.name ===
                    'DeviseSanctuaryVideoTakeover'
            ) {
                return true;
            }
            return false;
        },
    },
    watch: {
        breakpoint() {
            this.calculateNavigationSpacer();
        },
    },

    mounted() {
        this.$smoothReflow({
            el: this.$refs['navigation-submenu'],
        });
        this.calculateNavigationSpacer();

        let self = this;
        window.deviseSettings.$bus.$on('show-covid-19-link', () => {
            self.showCovidInfo = true;
        });

        // init lastScrollTop
        const st = window.pageYOffset || document.documentElement.scrollTop;
        const triggerOffest = 20;
        this.lastScrollTop = st <= 0 ? triggerOffest : st + triggerOffest;

        window.bus.$on('toggle-redesign-book-now', () => {
            this.showNavigationBooking = !this.showNavigationBooking;
        });
    },

    created() {
        window.addEventListener("scroll", () => {
            const st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > this.lastScrollTop) {
                this.collapsed = true;
            } else if (st < this.lastScrollTop) {
                this.collapsed = false;
            }
            this.lastScrollTop = st <= 0 ? 0 : st;
        }, false);
    },
    methods: {
        ...mapActions(['setAppStateProperty']),
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        inSubmenu() {
            this.subMenuShowing = true;
            clearTimeout(this.timeout);
        },
        showSubmenu(item, el) {
            const self = this;

            if (
                item.url === '#resort-dropdown' ||
                item.url === '#brands-dropdown' ||
                (typeof item.children !== 'undefined' &&
                    item.children.length > 0)
            ) {
                clearTimeout(this.timeout);

                this.$nextTick(function () {
                    self.subMenuShowing = true;
                    const subMenu = el.getElementsByClassName('submenu');
                    if (subMenu[0]) {
                        self.submenu = subMenu[0].innerHTML;
                    }

                    const rect = el.getBoundingClientRect();
                    // IE11 has rect.left
                    const rectX = rect.hasOwnProperty('x') ? rect.x : rect.left;
                    const left = Math.round(rectX) - 30;

                    let top = '';
                    var sAgent = window.navigator.userAgent;
                    var Idx = sAgent.indexOf('MSIE');
                    if (Idx > 0) {
                        const rectY = rect.hasOwnProperty('y')
                            ? rect.y
                            : rect.top;
                        top = `top: ${Math.round(rectY) + rect.height}px`;
                    }

                    this.$refs['navigation-submenu'].setAttribute(
                        'style',
                        `left: ${left}px; ${top}`
                    );
                });
            }
        },
        showMobileSubmenu(key) {
            if (this.showingMobileSubmenu === key) {
                this.showingMobileSubmenu = null;
            } else {
                this.showingMobileSubmenu = key;
            }
        },
        hideSubmenu() {
            const self = this;
            this.timeout = setTimeout(() => {
                self.subMenuShowing = false;
            }, 500);
        },
        switchLanguage(url) {
            window.location = url;
        },
        onDesktopPin() {
            true;
        },
        calculateNavigationSpacer() {
            const spacer = document.getElementById('desktop-navigation-spacer');
            const nav = document.getElementById('navigation');
            if (spacer && nav) {
                spacer.style.height = `${nav.clientHeight}px`;
            }
        },
    },
};
</script>
